import * as C from "@/components";
import React from "react";
import { VideoBackground } from "@/components/Video/VideoBackground";

const WorksWithCartsAndPodsSection = () => {
  return (
    <C.Card className="relative h-[184px] md:h-[400px] lg:h-[651px]">
      <VideoBackground
        videoSrc="https://images.active710.com/video/singular/510-adapter-animation.mp4"
        className="absolute inset-0 w-full h-full object-cover"
      />
    </C.Card>
  );
};

export default WorksWithCartsAndPodsSection;
